import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMessages } from "../../../shared/store/redux/entities-action";
import { selectEntitiesByFilters } from "../../../shared/store/views/entityView";
import { adminMessagesQuery, parseMessageFilters } from "../../../shared/utils/entitiesFiltersUtils";
import SystemMessagesEditorFlow from "./systemMessagesEditorFlow/SystemMessagesEditorFlow";
import SystemMessagesTable from "./systemMessagesTable/SystemMessagesTable";
import SystemMessagesEmptyState from "./systemMessagesEmptyState/SystemMessagesEmptyState";
import boardType from "../../../shared/enums/boardType";
import actionType from "../../../shared/enums/actionType";
import Card from "../../../shared/components/ui/card/Card";
import Icon from "../../../shared/components/ui/icons/Icon";
import iconsList from "../../../shared/components/ui/icons/iconsList";
import classes from "./SystemMessagesPage.module.css";

const EMPTY_DRAFT = { content: "", imageFile: null, fromDate: null, toDate: null, targetAudience: null, selectedGrades: [], isImportant: false };


const SystemMessagesPage = () => {
    const { texts, lang } = useSelector(state => state.translate);
    const messages = useSelector(state => selectEntitiesByFilters(state, adminMessagesQuery));
    const schoolId = useSelector(state => state.auth.userDetails?.defaultSchool?.id);
    const [editorState, setEditorState] = useState({ type: null, draft: null });
    const dispatch = useDispatch();
    const hasSchoolMessages = messages?.some(message => message.tags?.includes("school"));

    useEffect(() => {
        if (hasSchoolMessages) return;
        dispatch(getMessages({ boardId: boardType.dashboardMessages, schoolId, lang }));
    }, [dispatch, hasSchoolMessages, schoolId, lang]);

    const openAdd = () => {
        setEditorState({ type: actionType.add, draft: { ...EMPTY_DRAFT } });
    };

    const openEdit = (msg) => {
        const { targetAudience, selectedGrades } = parseMessageFilters(msg?.messageFilters);
        setEditorState({ type: actionType.edit, draft: { ...EMPTY_DRAFT, ...msg, targetAudience, selectedGrades } });
    };

    const openDelete = (msg) => {
        setEditorState({ type: actionType.delete, draft: msg });
    };

    const closeEditor = () => {
        setEditorState({ type: null, draft: null });
    };

    const handleSaved = () => closeEditor();

    const handleDraftChange = (patch) => {
        setEditorState(prev => {
            return { ...prev, draft: { ...prev.draft, ...patch } };
        });
    }

    return (
        <div className={classes.Page}>
            <div className={classes.PageHeader}>
                <div className={classes.PageHeaderText}>
                    <h1 className={classes.PageTitle}>{texts.systemMessagesPageTitle}</h1>
                    <p className={classes.PageSubtitle}>{texts.systemMessagesPageSubtitle}</p>
                </div>
                <button className={classes.AddBtn} onClick={openAdd}>
                    <Icon name={iconsList.addCircleButton} size="18px" color="white" />
                    <span>{texts.addSystemMessage}</span>
                </button>
            </div>
            <hr className={classes.Divider} />
            <Card>
                <p className={classes.CardTitle}>{texts.systemMessagesTitle}</p>
                {messages?.length > 0 ?
                    <div className={classes.TableWrap}>
                        <SystemMessagesTable
                            messages={messages}
                            onEdit={openEdit}
                            onDelete={openDelete}
                        />
                    </div>
                    :
                    <SystemMessagesEmptyState />
                }
            </Card>
            {editorState.type && (
                <SystemMessagesEditorFlow
                    type={editorState.type}
                    draft={editorState.draft}
                    onDraftChange={handleDraftChange}
                    onClose={closeEditor}
                    onSaved={handleSaved}
                />
            )}
        </div>
    );
};

export default SystemMessagesPage;
